import React, { memo } from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/logoImage.webp";

const Footer = () => {
  const footerLinks = {
    product: [
      { name: "Features", to: "/features" },
      { name: "Pricing", to: "/pricing" },
    ],
    company: [
      { name: "About Us", to: "/about" },
      { name: "Contact", to: "/contact-us" },
    ],
    legal: [
      { name: "Privacy Policy", to: "#" },
      { name: "Terms of Service", to: "#" },
    ],
  };

  return (
    <footer className="border-t bg-card mt-auto">
      <div className="max-w-[1400px] mx-auto px-4 py-12 lg:px-8">
        {/* -------- Top Section -------- */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* ---------- Brand Info ---------- */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src={logo}
                alt="MaalWahak"
                title="MaalWahak"
                className="h-8 w-auto"
                loading="lazy"
              />
            </div>
            <p className="text-sm text-[var(--gray-text)]">
              Empowering Indian transporters with smart TMS solutions for better
              business management.
            </p>
          </div>

          {/* ---------- Product Links ---------- */}
          <div>
            <h3 className="font-heading text-sm font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    className="text-[var(--gray-text)] hover:text-[var(--black)] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ---------- Company Links ---------- */}
          <div>
            <h3 className="font-heading text-sm font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    className="text-[var(--gray-text)] hover:text-[var(--black)] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ---------- Legal Links ---------- */}
          <div>
            <h3 className="font-heading text-sm font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              {footerLinks.legal.map((item) => (
                <li key={item.name}>
                  <span className="text-[var(--gray-text)] hover:text-[var(--black)] transition-colors cursor-pointer">
                    {item.name}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* -------- Bottom Section -------- */}
        <div className="mt-8 border-t pt-8 text-center text-sm text-[var(--gray-text)]">
          <p>© {new Date().getFullYear()} MaalWahak. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
